import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticated } from '@/utils/query-utils'
import { MaybeRef, toValue } from 'vue'

export const useListAnalysisImagesQuery = (analysisNumber: MaybeRef<string>, componentSid: MaybeRef<string>) => {
    return useQuery({
        queryKey: ['images', 'analysis', analysisNumber, componentSid],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.imagesApi.listAnalysisImages(toValue(analysisNumber), toValue(componentSid), { signal })
            
            return result
        },
        enabled: whenAuthenticated,
    })
}
